<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form label-width="100px" :model="queryCondition" ref="queryCondition" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="单据编号" prop="applyNo">
                    <el-input class="handle-input" v-model="queryCondition.applyNo" clearable placeholder="请输入单据编号" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="轮次状态" prop="roundStatus">
                    <el-select v-model="queryCondition.roundStatus" placeholder="轮次状态" clearable style="width:100%">
                      <el-option :label="$t('common.all')" value=""></el-option>
                      <el-option :key="index" v-for="(item,index) in roundStatusList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="入围供应商" style="width:100%">
                    <el-input class="handle-input" :disabled="true" v-model="supplierCode" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="主题" prop="subject">
                    <el-input class="handle-input" v-model="queryCondition.subject" clearable placeholder="请输入主题" style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="创建人" prop="buyerName">
                      <el-input class="handle-input" v-model="queryCondition.buyerName" clearable placeholder="请输入创建人" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(从)" prop="createDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="创建日期(至)" prop="createEndDate">
                      <el-date-picker value-format="yyyy-MM-dd" v-model="queryCondition.createEndDate" type="date" :placeholder="$t('common.selDate')" style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="8位码" prop="eightBitCodesStr">
                      <el-input v-model="queryCondition.eightBitCodesStr" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" clearable class="handle-input" placeholder="请输入8位码" style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
        </el-form>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
          <el-button size="mini" @click="restQueryFormThis()" type="primary">{{$t('common.reset')}}</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </div>

      <el-table :data="quotationList" ref="quotationDataTable" border max-height='470' highlight-current-row>
        <el-table-column label="选择" width="50">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" @change.native="getSelectRow(scope.row)" :label="scope.row.ttQuotationApplyRoundId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="date" label="单据编号" min-width="100px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationApplyDetail(scope.row)"> {{scope.row.applyNo}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="subject" label="主题" min-width="180px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="supplierNames" label="入围供应商" min-width="140px"></el-table-column>
        <el-table-column sortable label="操作" min-width="80px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationDetail(scope.row)" v-if="scope.row.roundStatus!=='4'">报价 </el-link>
            <!--报价-->
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="roundNumber" label="轮次" min-width="80px">
          <template slot-scope="scope">
            <el-link type="primary" @click="openQuotationHistory(scope.row.ttQuotationApplyId)"> {{scope.row.roundNumber}} </el-link>
          </template>
        </el-table-column>
        <el-table-column sortable prop="roundStatusI18n" label="轮次状态" min-width="90px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="name" label="创建人" min-width="120px"></el-table-column>
        <el-table-column sortable prop="createDate" label="创建日期" min-width="100px"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog el-dialog title="创建新轮次" :before-close="handleClose" :visible.sync="dialogVisible" width="80%">
        <el-form :model="createNewRoundForm" ref="createNewRoundForm" label-width="120px" inline="true">
          <el-form-item label="单据编号:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="主题:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="轮次:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="轮次说明:" prop="documentNumber" size="small">
            <el-input type="textarea" v-model="createNewRoundForm.documentNumber" style="width:200px"></el-input>
          </el-form-item>
          <el-form-item label="附件:" prop="documentNumber" size="small" style="width:320px">
            <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" :on-change="handleChange" :file-list="fileList">
              <el-button size="mini" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="primary" size="mini">提交</el-button>
          </el-form-item>
        </el-form>
        <el-table :data="quotationList" border highlight-current-row class="dialogIntable">
          <el-table-column show-overflow-tooltip sortable prop="date" label="供应商编号"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="name" label="供应商名称"></el-table-column>
          <el-table-column show-overflow-tooltip sortable prop="address" label="本轮是否发放"></el-table-column>
        </el-table>
      </el-dialog>
      <el-dialog el-dialog title="询报价详细" :before-close="handleClose" :visible.sync="quotationVisible" width="80%">
        <el-form :model="createNewRoundForm" ref="createNewRoundForm" label-width="120px" inline="true">
          <el-form-item label="单据编号:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="主题:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="创建人:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
          <el-form-item label="创建日期:" prop="documentNumber" size="small">
            <el-input v-model="createNewRoundForm.documentNumber" readonly />
          </el-form-item>
        </el-form>
      </el-dialog>
      <!--新轮次创建-->
      <el-dialog :title="$t('apply.newRound')" :visible.sync="showNewRoundDialog" width="65%">
        <!--创建新轮次-->
        <el-form ref="pickupPointForm" class="form_border" :label-position="labelPosition" label-width="120px">
          <div class="handle-box">
            <el-row>
              <el-button type="primary" size="mini" @click="saveNewRoundFunc" v-show="showSaveNewRoundFlag">{{$t('common.submit')}}</el-button>
              <!--提交-->
            </el-row>
            <el-form :model="newRoundHeadData" :label-position="labelPosition" ref="newRoundHeadDataForm" label-width="140px">
              <el-row :gutter="5">
                <el-col :span="7">
                  <el-form-item :label="$t('apply.no')">
                    <!--单据编号-->
                    <el-input v-model="newRoundHeadData.applyNo" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item :label="$t('apply.applyType')" prop="applyType">
                    <!--类型-->
                    <el-select v-model="newRoundHeadData.applyType" :disabled="true">
                      <el-option :key="index" v-for="(item,index) in applyTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="7">
                  <el-form-item :label="$t('apply.subject')">
                    <!--主题-->
                    <el-input v-model="newRoundHeadData.subject" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="5">
                <el-col :span="7">
                  <el-form-item :label="$t('apply.quotationType')" prop="quotationType">
                    <!--报价类型-->
                    <el-select v-model="newRoundHeadData.quotationType" :disabled="true">
                      <el-option :key="index" v-for="(item,index) in quotationTypeList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="7">
                  <el-form-item :label="$t('apply.round')">
                    <!--轮次-->
                    <el-input v-model="newRoundNumber" :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="5">
                <el-col :span="18">
                  <el-form-item :label="$t('apply.roundRemark')">
                    <!--轮次说明-->
                    <el-input type="textarea" v-model="roundRemark"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="5">
                <el-col :span="18">
                  <el-form-item :label="$t('common.attachment')" size="small">
                    <!--附件-->
                    <el-upload class="upload-demo" ref="upload" :headers="header" :action="fileUploadUrl" :on-success="uploadSuccess" :on-remove="handleRemove" multiple>
                      <el-button size="mini" type="primary">{{$t('common.selectFile')}}</el-button>
                      <!--选取文件-->
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="5">
                <el-col :span="18">
                  <el-table :data="supplierList" ref="supplierListDataTable" border highlight-current-row>
                    <el-table-column prop="supplierCode" :label="$t('apply.supplierCode')"></el-table-column>
                    <!--供应商编号-->
                    <el-table-column prop="supplierName" :label="$t('apply.supplierName')"></el-table-column>
                    <!--供应商名称-->
                    <!--本轮是否发放-->
                    <el-table-column width="55px" prop="tmSupplierId" :selectable="selectableMethod" type="selection" :label="$t('apply.whetherToIssue')"></el-table-column>
                  </el-table>
                </el-col>
              </el-row>

            </el-form>
          </div>
        </el-form>
        <!--新轮次创建-->

      </el-dialog>
    </div>
  </div>
</template>
<script>
import { getQuotationListData, roundInit, createNewRound, endQuotation, recoveryQuotation } from "@/api/quoteByProduct.js";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFunction from "@/utils/dataTableUtils";
import commonConstatns from "@/constants/commonConstants"
import store from '@/store/index'
import paginationMixin from '../../../../mixins/pagitionMixin';
export default {
  name: "inquiryQuotationProductSp",
  mixins: [paginationMixin],
  data() {
    return {
      isShow: false,//控制查询列表收缩展开
      activeName: "first",
      createNewRoundForm: {
        documentNumber: "2"
      },
      dialogVisible: false,
      quotationVisible: false,
      createFixedPointVisible: false,
      fileList: [],
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        applyNo: null,
        subject: null,
        supplierCode: null,
        roundNumber: null,
        roundStatus: null,
        buyerName: null,
        createDate: null,
        createEndDate: null,
        eightBitCodesStr: null,
        eightBitCodes: []
      },
      supplierCode: '',
      roundStatusList: [],
      quotationList: [],
      totalCount: 0,
      labelPosition: 'right',
      applyTypeList: [],
      quotationTypeList: [],

      newRoundHeadData: {},
      supplierList: [],
      newRoundNumber: null,
      ttQuotationApplyId: null,
      roundRemark: '',


      showSaveNewRoundFlag: true,
      fileUploadUrl: commonConstatns.fileUploadUrl,
      header: {
        'x-access-token': localStorage.getItem('token')
      },
      uploadFiles: [],
      showNewRoundDialog: false,
      ttQuotationApplyId: null,
      roundRemark: '',
      newRoundNumber: null,
      radioVal: null,
      selectRow: null,
      eightLists: []
    };
  },
  created() {
    this.getInputChoiceValues();
    // this.queryData(1);
  },
  watch: {
    queryCondition() {
      let _this = this;
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    console.log('to', to);
    const eightBitCodesStr = to.meta.reqData.eightBitCodesStr
    let eightBitCodesArr = []
    if (eightBitCodesStr && eightBitCodesStr.length > 0) {
      eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
    }
    const requestData = Object.assign({}, to.meta.reqData)
    requestData.eightBitCodes = eightBitCodesArr
    getQuotationListData(requestData).then((res) => {
      next(vm => {
        vm.queryCondition = requestData;
        vm.quotationList = res.resultData;
        vm.totalCount = res.totalCount;
        vm.supplierCode = res.otherInfo;
      })
    })
  },
  methods: {
    //单选操作
    getSelectRow: function (row) {
      this.selectRow = row;
    },
    //页面数据查询
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      const eightBitCodesStr = this.queryCondition.eightBitCodesStr
      let eightBitCodesArr = []
      if (eightBitCodesStr && eightBitCodesStr.length > 0) {
        eightBitCodesArr = eightBitCodesStr.trim().split(/[\n,，; \s]+/g);
      }
      const requestData = Object.assign({}, this.queryCondition)
      this.$set(requestData, 'eightBitCodes', eightBitCodesArr)
      getQuotationListData(requestData).then((res) => {
        this.quotationList = res.resultData;
        this.totalCount = res.totalCount;
        this.supplierCode = res.otherInfo;
      });
    },
    //点击报价
    openQuotationDetail: function (row) {
      console.log('row', row);
      this.$router.push({
        path: `/inquiry-quotation-product-sp-detail`,
        query: {
          roundId: row.ttQuotationApplyRoundId,
          ttQuotationId: row.ttQuotationId,
        }
      });
    },
    //点击轮次
    openQuotationHistory: function (applyId) {
      this.$router.push({
        path: `/inquiry-quotation-product-sp-history`,
        query: {
          applyId: applyId,
        }
      });
    },
    //详情
    openQuotationApplyDetail: function (row) {
      this.$router.push({
        path: `/product-quotation-application-sp-add`,
        query: {
          applyId: row.ttQuotationApplyId,
          source: "quotation"
        }
      });
    },
    //初始化创建新伦次
    showNewRoundDialogFunc: function () {
      let _this = this;
      _this.uploadFiles = [];
      if (_this.radioVal == null || _this.selectRow == null) {
        //请选择需创建新轮次的询价！
        _this.$message({ message: this.$t('apply.selectNewRoundQuote'), type: "warning" });
        return;
      }
      let quotation = _this.selectRow;
      if (!_this.selectRow.ownerFlag) {
        _this.$message({ message: "只能操作自己名下的单据", type: "warning" });
        return;
      }
      if (!(quotation.roundStatus == '2' && quotation.isLastRound == 'Y')) {
        //只有报价完成且最新轮次才可以进行新轮次创建！
        _this.$message({ message: this.$t('apply.newRoundCondition'), type: "warning" });
        return;
      }
      _this.newRoundNumber = null;
      _this.roundRemark = '';
      _this.ttQuotationApplyId = null;
      roundInit(_this.selectRow).then((res) => {
        if (res.quotationApply.source == 'SUP') {//如何申请单是供应商创建的则不可以编辑供应商
          _this.newRoundMCDFlag = false;
        }
        _this.newRoundHeadData = res.quotationApply;
        _this.supplierList = res.supplierList;
        _this.newRoundNumber = res.roundNumber;
        _this.ttQuotationApplyId = res.ttQuotationApplyId;
        _this.showNewRoundDialog = true;
        _this.supplierList.forEach(row => {
          _this.$nextTick(() => {
            _this.supplierList.forEach(row => {
              _this.$refs.supplierListDataTable.toggleRowSelection(row, true);
            })
          })
        })
      })

    },
    //新轮次创建
    saveNewRoundFunc: function () {
      let _this = this;
      //判断是否选择了供应商
      let rows = this.$refs.supplierListDataTable.selection;
      if (rows.length == 0) {
        //请选择需要发放的供应商
        _this.$message({ message: this.$t('apply.selectPublishSupplier'), type: "warning" });
      }
      this.showSaveNewRoundFlag = false;
      let supIds = [];
      rows.forEach((item) => {
        supIds.push(item.tmSupplierId);
      });
      let quotationInfo = {};
      quotationInfo.roundNumber = this.newRoundNumber;
      quotationInfo.roundRemark = this.roundRemark;
      quotationInfo.supplierIds = supIds;
      quotationInfo.listDoc = this.uploadFiles;
      quotationInfo.ttQuotationApplyId = this.ttQuotationApplyId;
      createNewRound(quotationInfo).then((res) => {
        _this.radioVal = null;
        _this.selectRow = null;
        //创建成功
        _this.$message({ message: this.$t('common.createSuccess'), type: "success" });
        _this.showNewRoundDialog = false;
        _this.queryData();
        _this.showSaveNewRoundFlag = true;
      }).catch((error) => {
        _this.showSaveNewRoundFlag = true;
      })
    },
    //结束询价，只有报价完成的单据可以结束报价，结束报价后可以进行报价确认操作
    endQuotationFunc: function () {
      let _this = this;
      if (_this.radioVal == null || _this.selectRow == null) {
        //请选择需要结束的询价！
        _this.$message({ message: this.$t('apply.selectEndQuote'), type: "warning" });
        return;
      } else {
        if (!_this.selectRow.ownerFlag) {
          _this.$message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //收集可以结束的报价ID(只有报价完的才可以结束报价)
        if (_this.selectRow.quotationStatus != '2') {
          //请选择报价状态为报价完成的单据进行操作！
          _this.$message({ message: this.$t('apply.selectCompletedQuotationStatus'), type: "warning" });
          return;
        }
      }
      endQuotation(_this.selectRow.ttQuotationId).then((res) => {
        if (res.meta.success) {
          _this.selectRow = null;
          _this.radioVal = null;
          //结束询价成功
          _this.$message({ message: this.$t('apply.closeRFQSuccess'), type: "success" });
          this.queryData();
        } else {
          _this.$message({ message: res.meta.msg, type: "warning" });
          //转到报价详情，让用户维护预估年总费用
          let roundId = _this.selectRow.ttQuotationApplyRoundId;
          this.$router.push({
            path: `/inquiry-quotation-product-sp-detail`,
            query: {
              roundId: roundId,
              from: "eq"
            }
          });
        }

      })
    },
    //恢复询价:只能恢复最新轮次，且轮次状态为结束询价的
    recoveryQuotationFunc: function () {
      let _this = this;
      let ids = [];
      if (_this.radioVal == null || _this.selectRow == null) {
        //请选择需要恢复的询价！
        _this.$message({ message: _this.$t('apply.selectResumeQuote'), type: "warning" });
        return;
      } else {
        if (!_this.selectRow.ownerFlag) {
          _this.$message({ message: "只能操作自己名下的单据", type: "warning" });
          return;
        }
        //收集可以进行恢复报价ID(只有结束报价的才可以恢复报价)
        if (_this.selectRow.roundStatus == '3' && _this.selectRow.isLastRound == 'Y') {
          ids.push(_this.selectRow.ttQuotationId);
        }
        if (ids.length == 0) {
          //只有最新轮次且轮次状态为结束询价的才能进行恢复操作！
          _this.$message({ message: _this.$t('apply.resumeQuoteCondition'), type: "warning" });
          return;
        }
      }
      recoveryQuotation(ids[0]).then((res) => {
        _this.radioVal = null;
        _this.selectRow = null;
        //恢复询价成功

        _this.$message({ message: _this.$t('apply.resumeRFQSuccess'), type: "success" });
        _this.queryData();
      })
    },
    selectableMethod: function (row) {
      return this.newRoundMCDFlag;
    },
    //文件上传成功回调
    uploadSuccess: function (response, file, fileList) {
      this.uploadFiles.push(...response.data);
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"] = "TT_QUOTATION_APPLY_ROUND:ROUND_STATUS";
      mapObj["TT_QUOTATION:STATUS"] = "TT_QUOTATION:STATUS";
      mapObj["TT_SOURCING:STATUS"] = "TT_SOURCING:STATUS";
      mapObj["TT_QUOTATION_APPLY:QUOTATION_TYPE"] = "TT_QUOTATION_APPLY:QUOTATION_TYPE";
      mapObj["TT_QUOTATION_APPLY:APPLY_TYPE"] = "TT_QUOTATION_APPLY:APPLY_TYPE";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.roundStatusList = res["TT_QUOTATION_APPLY_ROUND:ROUND_STATUS"];
        this.quotationStatusList = res["TT_QUOTATION:STATUS"];
        this.sourcingStatusList = res["TT_SOURCING:STATUS"];
        this.quotationTypeList = res["TT_QUOTATION_APPLY:QUOTATION_TYPE"];
        this.applyTypeList = res["TT_QUOTATION_APPLY:APPLY_TYPE"];
      });
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 3 个文件，本次选择了 ${files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleChange(file, fileList) {
      console.log(fileList);
      this.fileList = fileList.slice(-1);
    },
    handleClose() {
      this.dialogVisible = false;
      this.quotationVisible = false;
      this.createFixedPointVisible = false;
    },
    handleSelectionChange(val) {
      // this.multipleSelection = val;
    },
    add() { },
    del() {
      var that = this;
      that
        .$confirm("请确认是否删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          console.log("确认删除");
        })
        .catch(() => { });
    },
    close() {
      var that = this;
      that
        .$confirm("请确认是否关闭?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          console.log("确认删除");
        })
        .catch(() => { });
    },
    checkRoundNumber: function (val) {
      if (undefined != val) {
        let reg = /^(0|[1-9]\d{0,9})$/;
        if (!reg.test(val)) {
          this.queryCondition.roundNumber = 1;
        }
      }
    },
    restQueryFormThis: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition.pageSize = 15;
      this.queryCondition.pageNum = 1;
      this.queryCondition.eightBitCodes = [];
      this.queryCondition.createEndDate = "";
      this.radioVal = ""
      this.queryCondition.createDate = ''
      this.queryCondition.createEndDate = ''
      this.queryData()
    },
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
.inquiryQuotationProduct {
  .toolsBox {
    margin-bottom: 10px;
  }
  .btnsWarp {
    text-align: right;
    margin-top: 20px;
  }
  .dialogIntable {
    margin-top: 20px;
  }
  .a-link {
    text-decoration: underline;
  }
  .el-select {
    width: 100%;
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
}
</style>
